module.exports = __webpack_public_path__ + "img/ai_icon_logo.52e37ece.png";